export const UNLOCK_ACCOUNT_STAGES = {
  INITIAL: 'initial',
  ERROR: 'error',
}
